import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
	title: {
		fontWeight: 600,
		textAlign: 'left',
	},
});
